import { verdictMeta } from "../lib/compute";

const TONES = {
  emerald: "bg-emerald-950/60 border-emerald-600/60 text-emerald-400",
  amber: "bg-amber-950/50 border-amber-600/60 text-amber-400",
  red: "bg-red-950/50 border-red-600/60 text-red-400",
};

export function VerdictBadge({ verdict, className = "", "data-testid": testid }) {
  const m = verdictMeta(verdict);
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-xs font-mono2 font-bold tracking-wide ${TONES[m.tone]} ${className}`}
      title={m.desc}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {m.label}
    </span>
  );
}
